import { Exact } from "src/generated/graphql";
import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import { Apollo, Query } from "apollo-angular";

export type GetRemunerationParametersQueryVariables = Exact<{ [key: string]: never }>;

export type GetRemunerationParametersQuery = {
  getRemunerationParameters: [
    {
      id: number;
      name: string;
    }
  ];
};

export const GetRemunerationParametersDocument = gql`
  query GetRemunerationParameters {
    getRemunerationParameters {
      id
      name
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetRemunerationParametersGQL extends Query<GetRemunerationParametersQuery, GetRemunerationParametersQueryVariables> {
  document = GetRemunerationParametersDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
